// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/auth/v1/permissions.proto (package chalk.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_utils_v1_encoding } from "../../utils/v1/encoding_pb";
import type { EnumValueOptions, MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file chalk/auth/v1/permissions.proto.
 */
export const file_chalk_auth_v1_permissions: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_utils_v1_encoding, file_google_protobuf_descriptor]);

/**
 * Principal types that a permission may be assigned to directly. User-role
 * assignment is managed separately; this metadata controls non-user principals.
 *
 * @generated from enum chalk.auth.v1.PermissionPrincipal
 */
export enum PermissionPrincipal {
  /**
   * @generated from enum value: PERMISSION_PRINCIPAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMISSION_PRINCIPAL_SERVICE_TOKEN = 1;
   */
  SERVICE_TOKEN = 1,
}

/**
 * Describes the enum chalk.auth.v1.PermissionPrincipal.
 */
export const PermissionPrincipalSchema: GenEnum<PermissionPrincipal> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_permissions, 0);

/**
 * @generated from enum chalk.auth.v1.Permission
 */
export enum Permission {
  /**
   * @generated from enum value: PERMISSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMISSION_INSECURE_UNAUTHENTICATED = 1;
   */
  INSECURE_UNAUTHENTICATED = 1,

  /**
   * This permissions should be used sparingly
   * (e.g. for ping checks that shouldn't be exposed to the public)
   *
   * @generated from enum value: PERMISSION_AUTHENTICATED = 2;
   */
  AUTHENTICATED = 2,

  /**
   * @generated from enum value: PERMISSION_QUERY_ONLINE = 3;
   */
  QUERY_ONLINE = 3,

  /**
   * @generated from enum value: PERMISSION_QUERY_OFFLINE = 4;
   */
  QUERY_OFFLINE = 4,

  /**
   * @generated from enum value: PERMISSION_MONITORING_CREATE = 5;
   */
  MONITORING_CREATE = 5,

  /**
   * @generated from enum value: PERMISSION_MONITORING_READ = 6;
   */
  MONITORING_READ = 6,

  /**
   * @generated from enum value: PERMISSION_TEAM_ADD = 7;
   */
  TEAM_ADD = 7,

  /**
   * @generated from enum value: PERMISSION_TEAM_DELETE = 8;
   */
  TEAM_DELETE = 8,

  /**
   * @generated from enum value: PERMISSION_TEAM_LIST = 9;
   */
  TEAM_LIST = 9,

  /**
   * @generated from enum value: PERMISSION_TEAM_ADMIN = 10;
   */
  TEAM_ADMIN = 10,

  /**
   * @generated from enum value: PERMISSION_DEPLOY_READ = 11;
   */
  DEPLOY_READ = 11,

  /**
   * @generated from enum value: PERMISSION_DEPLOY_CREATE = 12;
   */
  DEPLOY_CREATE = 12,

  /**
   * @generated from enum value: PERMISSION_DEPLOY_PREVIEW = 13;
   */
  DEPLOY_PREVIEW = 13,

  /**
   * @generated from enum value: PERMISSION_DEPLOY_REDEPLOY = 14;
   */
  DEPLOY_REDEPLOY = 14,

  /**
   * @generated from enum value: PERMISSION_LOGS_LIST = 15;
   */
  LOGS_LIST = 15,

  /**
   * @generated from enum value: PERMISSION_CRON_READ = 16;
   */
  CRON_READ = 16,

  /**
   * @generated from enum value: PERMISSION_CRON_CREATE = 17;
   */
  CRON_CREATE = 17,

  /**
   * @generated from enum value: PERMISSION_SECRETS_WRITE = 18;
   */
  SECRETS_WRITE = 18,

  /**
   * @generated from enum value: PERMISSION_SECRETS_DECRYPT = 19;
   */
  SECRETS_DECRYPT = 19,

  /**
   * @generated from enum value: PERMISSION_SECRETS_LIST = 20;
   */
  SECRETS_LIST = 20,

  /**
   * @generated from enum value: PERMISSION_TOKENS_WRITE = 21;
   */
  TOKENS_WRITE = 21,

  /**
   * @generated from enum value: PERMISSION_TOKENS_LIST = 22;
   */
  TOKENS_LIST = 22,

  /**
   * @generated from enum value: PERMISSION_MIGRATE_READ = 23;
   */
  MIGRATE_READ = 23,

  /**
   * @generated from enum value: PERMISSION_MIGRATE_PLAN = 24;
   */
  MIGRATE_PLAN = 24,

  /**
   * @generated from enum value: PERMISSION_MIGRATE_EXECUTE = 25;
   */
  MIGRATE_EXECUTE = 25,

  /**
   * @generated from enum value: PERMISSION_PROJECT_CREATE = 26;
   */
  PROJECT_CREATE = 26,

  /**
   * @generated from enum value: PERMISSION_CHALK_ADMIN = 27;
   */
  CHALK_ADMIN = 27,

  /**
   * @generated from enum value: PERMISSION_BILLING_READ = 28;
   */
  BILLING_READ = 28,

  /**
   * @generated from enum value: PERMISSION_AUTH_SERVICE_MANAGER = 29;
   */
  AUTH_SERVICE_MANAGER = 29,

  /**
   * @generated from enum value: PERMISSION_INFRASTRUCTURE_READ = 30;
   */
  INFRASTRUCTURE_READ = 30,

  /**
   * @generated from enum value: PERMISSION_INFRASTRUCTURE_WRITE = 31;
   */
  INFRASTRUCTURE_WRITE = 31,

  /**
   * @generated from enum value: PERMISSION_ENVIRONMENT_CREATE = 32;
   */
  ENVIRONMENT_CREATE = 32,

  /**
   * @generated from enum value: PERMISSION_INTERNAL_DATAPLANE_STATUS_UPDATE = 33;
   */
  INTERNAL_DATAPLANE_STATUS_UPDATE = 33,

  /**
   * @generated from enum value: PERMISSION_INTERNAL_WORKING_TOKEN_EXCHANGE = 34;
   */
  INTERNAL_WORKING_TOKEN_EXCHANGE = 34,

  /**
   * @generated from enum value: PERMISSION_BILLING_WRITE = 35;
   */
  BILLING_WRITE = 35,

  /**
   * @generated from enum value: PERMISSION_QUERY_OFFLINE_READ = 36;
   */
  QUERY_OFFLINE_READ = 36,

  /**
   * @generated from enum value: PERMISSION_INTERNAL_RESOURCE_SHARE_VIEW = 37;
   */
  INTERNAL_RESOURCE_SHARE_VIEW = 37,

  /**
   * @generated from enum value: PERMISSION_INTERNAL_EXCHANGE_TOKEN_RENEW = 38;
   */
  INTERNAL_EXCHANGE_TOKEN_RENEW = 38,

  /**
   * @generated from enum value: PERMISSION_AGENTS_WRITE = 39;
   */
  AGENTS_WRITE = 39,

  /**
   * @generated from enum value: PERMISSION_AGENTS_READ = 40;
   */
  AGENTS_READ = 40,

  /**
   * @generated from enum value: PERMISSION_BILLING_PUBLISH_ANALYTICS = 41;
   */
  BILLING_PUBLISH_ANALYTICS = 41,

  /**
   * @generated from enum value: PERMISSION_NOTEBOOK_WRITE = 42;
   */
  NOTEBOOK_WRITE = 42,
}

/**
 * Describes the enum chalk.auth.v1.Permission.
 */
export const PermissionSchema: GenEnum<Permission> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_permissions, 1);

/**
 * @generated from extension: string description = 1001;
 */
export const description: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 0);

/**
 * @generated from extension: string slug = 1002;
 */
export const slug: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 1);

/**
 * @generated from extension: repeated chalk.auth.v1.PermissionPrincipal assignable_to = 1003;
 */
export const assignable_to: GenExtension<EnumValueOptions, PermissionPrincipal[]> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 2);

/**
 * @generated from extension: chalk.auth.v1.Permission permission = 2000;
 */
export const permission: GenExtension<MethodOptions, Permission> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 3);

/**
 * @generated from extension: chalk.auth.v1.Permission team_permission = 2001;
 */
export const team_permission: GenExtension<MethodOptions, Permission> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 4);

/**
 * Additional permissions accepted in place of `permission` (OR semantics).
 * The effective set of acceptable permissions for an endpoint is the union
 * of `permission` and `additional_permissions_list`: a user holding any
 * single permission in that union may access the endpoint. Use this to
 * expose read-only access to a narrower role without disturbing the
 * existing primary permission (e.g. permission = PERMISSION_QUERY_OFFLINE,
 * additional_permissions_list = [PERMISSION_QUERY_OFFLINE_READ]).
 *
 * @generated from extension: repeated chalk.auth.v1.Permission additional_permissions_list = 2002;
 */
export const additional_permissions_list: GenExtension<MethodOptions, Permission[]> = /*@__PURE__*/
  extDesc(file_chalk_auth_v1_permissions, 5);

